export const SUBSCRIBE = 'SUBSCRIBE';
export const SUBMIT_CONTACT = 'SUBMIT_CONTACT';
export const POST_QUOTE = 'POST_QUOTE';
export const POST_LOGIN = 'POST_LOGIN';
export const POST_SIGNUP = 'POST_SIGNUP';
export const POST_RESET_PASSWORD = 'POST_RESET_PASSWORD';
export const GET_SEARCH = 'GET_SEARCH';
export const POST_COMMENT = 'POST_COMMENT';